import { isHeroBrandEnabled } from './heroBrandUtils';

export const TULKA_PREBOOKING_DURATIONS = [
  10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60,
  75, 90, 105, 120,
  150, 180, 210, 240, 300, 360, 420, 480,
];

const HERO_QUARTER_HOURS_4H_TO_8H = Array.from({ length: 17 }, (_, i) => 240 + i * 15);

export const HERO_PREBOOKING_DURATIONS = [...new Set([...TULKA_PREBOOKING_DURATIONS, ...HERO_QUARTER_HOURS_4H_TO_8H])]
  .sort((a, b) => a - b);

export const getBrandPrebookingDurations = (isHero = isHeroBrandEnabled()) => {
  return isHero ? HERO_PREBOOKING_DURATIONS : TULKA_PREBOOKING_DURATIONS;
};

export const getPrebookingDurations = ({
  durations,
  minMinutes = 0,
  maxMinutes = Infinity,
  currentMinutes = [],
}) => {
  const isWithinBounds = minutes => minutes >= minMinutes && minutes <= maxMinutes;
  const current = (Array.isArray(currentMinutes) ? currentMinutes : [currentMinutes])
    .filter(minutes => Number.isInteger(minutes) && minutes > 0);

  return [...new Set([...durations, ...current])]
    .filter(isWithinBounds)
    .sort((a, b) => a - b);
};
